
import {defineComponent} from "vue";
import UserApi from "@/api/UserApi";
import {Operation} from "@/api/Models";
import GCard from "@/components/Base/GCard.vue";
import BLoader from "@/components/BLoader/BLoader.vue";

export default defineComponent({
    components: {BLoader, GCard},
    props: {
        needReload: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    created() {
        this.loadOperations()
    },
    data() {
        return {
            state: {
                isLoading: false
            },
            operations: [] as Array<Operation>,
            to: 0,
            total: 0,
            page: 0,
            types: {
                replenish_online: 'Пополнение онлайн',
                cashback: 'Кэшбэк',
                waste: 'Списание',
            }
        }
    },
    watch: {
        needReload: function () {
            this.operations = []
            this.page = 0
            this.loadOperations();
        }
    },
    methods: {
        loadOperations() {
            this.page++
            this.state.isLoading = true
            UserApi
                .operations({
                    page: this.page,
                    qty: 5
                })
                .then(response => {
                    this.operations = this.operations.concat(response.data.data)
                    this.to = response.data.to
                    this.total = response.data.total
                })
                .finally(() => {
                    this.state.isLoading = false
                })
        }
    }
})
